import BasicDataTablesContainer from "../../Componant/DataTable/BasicDataTables";

const BasicDataTables = () => {
  return (
    <div className="page-body">
      <BasicDataTablesContainer />
    </div>
  );
};

export default BasicDataTables;
